(() => {
  'use strict';
  if (window.AWEcosystemP1Enrichment?.version) return;

  const URLS = {
    garage: '/pages/mon-atelier-airsoft#aw-garage',
    projects: '/pages/mon-atelier-airsoft#aw-projets',
    compatibility: '/pages/compatibilite-airsoft',
    atelier: '/pages/notre-atelier-de-preparation-de-repliques-airsoft#aw-atelier-prestations'
  };
  const TYPE_SERVICES = {
    aeg: [
      'diagnostic-aeg-airsoft-panne-bruit-chauffe-ou-perte-de-puissance',
      'forfait-revision-aeg',
      'installation-mosfet-etu-aeg-montage-cablage-et-configuration',
      'reglage-et-optimisation-hop-up-airsoft-montage-alignement-et-tests'
    ],
    gbb: [
      'forfait-revision-entretien-replique-de-poing-gbb',
      'diagnostic-fuite-gaz-gbb-gbbr-chargeur-valves-joints-et-nozzle',
      'reglage-et-optimisation-hop-up-airsoft-montage-alignement-et-tests'
    ],
    gbbr: [
      'revision-et-entretien-gbbr-airsoft-culasse-nozzle-valves-et-etancheite',
      'diagnostic-fuite-gaz-gbb-gbbr-chargeur-valves-joints-et-nozzle',
      'reglage-et-optimisation-hop-up-airsoft-montage-alignement-et-tests'
    ],
    hpa: [
      'entretien-hpa-airsoft-moteur-fcu-etancheite-ligne-et-reglages',
      'installation-moteur-hpa-airsoft-montage-alignement-fcu-et-tests',
      'reglage-et-optimisation-hop-up-airsoft-montage-alignement-et-tests'
    ],
    aep: [
      'revision-aep-airsoft-gearbox-compacte-moteur-connectique-et-hop-up',
      'reglage-et-optimisation-hop-up-airsoft-montage-alignement-et-tests'
    ]
  };

  const normalize = (value = '') => String(value || '').trim().toLowerCase().normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '').replace(/&/g, ' et ').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const list = (value = '') => String(value || '').split(',').map((item) => item.trim()).filter(Boolean);
  const bridge = () => window.AWEcosystemP1Bridge || null;
  const activeReplica = () => bridge()?.activeReplica?.() || null;
  const currentContext = () => {
    try { return window.AWAirsoftContext?.current?.() || JSON.parse(localStorage.getItem('aw_airsoft_context_v1') || '{}'); }
    catch (_) { return {}; }
  };
  const recordFromNode = (node) => node ? {
    handle: String(node.dataset.handle || '').trim(),
    label: String(node.dataset.label || '').trim(),
    model: String(node.dataset.model || '').trim(),
    manufacturer: String(node.dataset.manufacturer || '').trim(),
    platform: String(node.dataset.platform || '').trim(),
    platformLabel: String(node.dataset.platformLabel || '').trim(),
    type: String(node.dataset.type || '').trim(),
    pageUrl: String(node.dataset.pageUrl || '').trim(),
    workshopServices: list(node.dataset.workshopServices)
  } : null;
  const recordByHandle = (handle) => {
    const wanted = String(handle || '').trim();
    if (!wanted) return null;
    const node = Array.from(document.querySelectorAll('[data-aw-tool-model],[data-aw-model-context-model]'))
      .find((item) => String(item.dataset.handle || '').trim() === wanted);
    return recordFromNode(node);
  };
  const requestedRecord = () => recordByHandle(new URLSearchParams(location.search).get('aw_model') || '');
  const exactFromContext = () => {
    const byUrl = requestedRecord();
    if (byUrl) return byUrl;
    const ctx = currentContext();
    const byHandle = recordByHandle(ctx?.modelHandle);
    if (byHandle) return byHandle;
    if (!ctx?.model && !ctx?.modelLabel) return null;
    return bridge()?.resolveExactModel?.({
      manufacturer: ctx.manufacturerLabel || ctx.manufacturer || '',
      model: ctx.model || ctx.modelLabel || '',
      platform: ctx.platform || '',
      type: ctx.type || ctx.replicaType || ''
    }) || null;
  };
  const currentRecord = () => {
    const byUrl = requestedRecord();
    if (byUrl) return byUrl;
    const replica = activeReplica();
    return replica ? bridge()?.resolveExactModel?.(replica) || null : exactFromContext();
  };
  const exactUrl = (base, record, source = 'ecosystem') => {
    if (!base || !record?.handle) return base || '';
    try {
      const url = new URL(base, location.origin);
      url.searchParams.set('aw_model', record.handle);
      if (!url.searchParams.has('aw_from')) url.searchParams.set('aw_from', source);
      return `${url.pathname}${url.search}${url.hash}`;
    } catch (_) { return base; }
  };
  const typeKey = (value = '') => {
    const type = normalize(value);
    if (type.includes('gbbr')) return 'gbbr';
    if (type.includes('aep')) return 'aep';
    if (type.includes('hpa')) return 'hpa';
    if (type.includes('aeg')) return 'aeg';
    if (type.includes('gbb')) return 'gbb';
    return '';
  };
  const recordLabel = (record) => String(record?.label || [record?.manufacturer, record?.model].filter(Boolean).join(' ') || 'Modèle exact AW').trim();
  const productHandle = (link) => {
    try { return String(new URL(link.href, location.origin).pathname.match(/^\/products\/([^/?#]+)/i)?.[1] || '').trim(); }
    catch (_) { return ''; }
  };
  const serviceCards = (handle) => {
    const wanted = normalize(handle);
    if (!wanted) return [];
    return Array.from(document.querySelectorAll('.aw14-card')).filter((card) => {
      const direct = normalize(card.dataset.awServiceHandle || '');
      if (direct === wanted) return true;
      return Array.from(card.querySelectorAll('a[href*="/products/"]')).some((link) => normalize(productHandle(link)) === wanted);
    });
  };
  const clearOurMarks = () => {
    document.querySelectorAll('[data-aw-ecosystem-enrichment-match]').forEach((card) => {
      card.classList.remove('is-aw-active-service');
      delete card.dataset.awEcosystemEnrichmentMatch;
      card.querySelectorAll('[data-aw-ecosystem-enrichment-note]').forEach((note) => note.remove());
    });
    document.querySelectorAll('[data-aw-ecosystem-enrichment-status]').forEach((node) => node.remove());
  };
  const markCard = (card, mode, text) => {
    if (!card) return false;
    card.classList.add('is-aw-active-service');
    card.dataset.awEcosystemEnrichmentMatch = mode;
    if (!card.querySelector('[data-aw-ecosystem-enrichment-note]')) {
      const note = document.createElement('p');
      note.dataset.awEcosystemEnrichmentNote = 'true';
      note.className = 'aw-ecosystem-p1-service-note';
      note.textContent = text;
      const footer = card.querySelector('.aw14-card__footer');
      if (footer) footer.before(note);
      else card.append(note);
    }
    return true;
  };
  const renderServiceContext = () => {
    const specialized = document.querySelector('#aw-atelier-specialized-services');
    if (!specialized) return;
    clearOurMarks();
    const record = currentRecord();
    if (!record) return;

    const exact = Array.isArray(record.workshopServices) ? record.workshopServices.filter(Boolean) : list(record.workshopServices);
    let visible = 0;
    let mode = 'none';
    let candidates = [];
    if (exact.length) {
      mode = 'exact';
      exact.forEach((handle) => serviceCards(handle).forEach((card) => {
        if (markCard(card, 'exact', 'Relation Atelier exacte enregistrée dans Shopify pour ce modèle. Vérifiez le périmètre réel de la prestation avant intervention.')) visible += 1;
      }));
    } else {
      const key = typeKey(record.type || currentContext().type || '');
      candidates = key ? TYPE_SERVICES[key] || [] : [];
      mode = candidates.length ? 'type-candidate' : 'none';
      candidates.forEach((handle) => serviceCards(handle).forEach((card) => {
        if (markCard(card, 'type-candidate', `Suggestion AW selon le type ${String(record.type || key).toUpperCase()} déclaré. À confirmer selon la version exacte : ce n’est pas une relation Compatibility enregistrée dans Shopify.`)) visible += 1;
      }));
    }

    const status = document.createElement('div');
    status.dataset.awEcosystemEnrichmentStatus = 'true';
    status.className = 'aw-ecosystem-p1-service-note';
    const explicit = Boolean(requestedRecord());
    const sourceLabel = activeReplica() && !explicit ? 'Garage' : 'Compatibility';
    if (mode === 'exact') {
      status.textContent = `Contexte ${sourceLabel} : ${recordLabel(record)} · ${exact.length} relation${exact.length > 1 ? 's' : ''} Atelier exacte${exact.length > 1 ? 's' : ''} enregistrée${exact.length > 1 ? 's' : ''} · ${visible} prestation${visible > 1 ? 's' : ''} visible${visible > 1 ? 's' : ''} sur cette page.`;
    } else if (mode === 'type-candidate') {
      status.textContent = `Contexte ${sourceLabel} : ${recordLabel(record)} · aucune relation Atelier exacte enregistrée. ${candidates.length} prestation${candidates.length > 1 ? 's' : ''} candidate${candidates.length > 1 ? 's' : ''} proposée${candidates.length > 1 ? 's' : ''} selon le type déclaré, à confirmer avant intervention.`;
    } else {
      status.textContent = `Contexte ${sourceLabel} : ${recordLabel(record)} · aucune relation Atelier exacte ni suggestion sûre par type n’est appliquée automatiquement.`;
    }
    specialized.querySelector('.aw14-block__head')?.insertAdjacentElement('afterend', status);
  };
  const renderAnchors = () => {
    const garage = document.querySelector('.aw-p2-garage');
    if (garage && !garage.id) garage.id = 'aw-garage';
    const projects = document.querySelector('[data-aw-atelier]');
    if (projects && !projects.id) projects.id = 'aw-projets';
    document.querySelectorAll('.aw14-nav a[href="/pages/mon-atelier-airsoft"]').forEach((link) => {
      link.textContent = 'Garage & projets';
      link.href = URLS.garage;
    });
  };
  const renderCompatibilityContextStrip = () => {
    const explicit = requestedRecord();
    if (activeReplica() && !explicit) return;
    const record = explicit || exactFromContext();
    if (!record) return;
    document.querySelectorAll('[data-aw-ecosystem-context]').forEach((strip) => {
      const eyebrow = strip.querySelector('.aw-ecosystem-p1-context__eyebrow');
      const title = strip.querySelector('.aw-ecosystem-p1-context__title');
      const meta = strip.querySelector('.aw-ecosystem-p1-context__meta');
      const actions = strip.querySelector('.aw-ecosystem-p1-context__actions');
      if (eyebrow) eyebrow.textContent = 'Contexte Compatibility';
      if (title) title.textContent = recordLabel(record);
      if (meta) {
        const details = [record.platformLabel || record.platform, record.type].filter(Boolean);
        if (record.workshopServices?.length) details.push(`${record.workshopServices.length} relation${record.workshopServices.length > 1 ? 's' : ''} Atelier exacte${record.workshopServices.length > 1 ? 's' : ''}`);
        details.push('aucune fiche Garage créée automatiquement');
        meta.textContent = details.join(' · ');
      }
      if (actions) {
        actions.replaceChildren();
        [
          ['Ouvrir le Garage', exactUrl(URLS.garage, record, 'compatibility')],
          ['Mes projets', exactUrl(URLS.projects, record, 'compatibility')],
          [record.pageUrl ? 'Fiche Compatibility' : 'Compatibility', record.pageUrl || exactUrl(URLS.compatibility, record, 'ecosystem')],
          ['Atelier', exactUrl(URLS.atelier, record, 'compatibility')]
        ].forEach(([label, href]) => {
          const link = document.createElement('a');
          link.className = 'aw-ecosystem-p1-link';
          link.href = href;
          link.textContent = label;
          actions.append(link);
        });
      }
    });
  };
  const syncCanonicalGarageContext = (replica) => {
    if (!replica || !window.AWAirsoftContext?.write || !bridge()?.resolveExactModel) return;
    const record = bridge().resolveExactModel(replica);
    if (!record) return;
    window.AWAirsoftContext.write({
      platform: record.platform,
      platformLabel: record.platformLabel || record.platform,
      manufacturer: record.manufacturer,
      manufacturerLabel: record.manufacturer,
      type: record.type,
      typeLabel: record.type,
      model: record.model,
      modelLabel: record.label || record.model,
      modelHandle: record.handle
    }, 'garage-exact-model-canonical');
  };

  let timer = 0;
  const render = () => {
    clearTimeout(timer);
    timer = window.setTimeout(() => {
      renderAnchors();
      renderCompatibilityContextStrip();
      renderServiceContext();
    }, 25);
  };

  window.addEventListener('aw:garage-context-changed', (event) => {
    syncCanonicalGarageContext(event.detail?.replica || activeReplica());
    render();
  });
  ['aw:context-changed', 'aw:compatibility-changed', 'aw:model-index-ready', 'aw:p2-garage-updated'].forEach((name) => window.addEventListener(name, render));
  document.addEventListener('shopify:section:load', render);
  window.addEventListener('storage', (event) => {
    if (['aw_airsoft_context_v1', 'aw_garage_active_replica_v1', 'aw_garage_replicas_v1'].includes(event.key)) render();
  });

  window.AWEcosystemP1Enrichment = {
    version: '1.1.0',
    render,
    exactFromContext,
    currentRecord,
    typeKey,
    candidateServiceHandles: (type) => [...(TYPE_SERVICES[typeKey(type)] || [])],
    policy: 'explicit-aw-model-first;exact-relations-first;type-fallback-is-candidate-only;never-create-garage-record'
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render, { once: true });
  else render();
})();
